import { useMutation } from "@tanstack/react-query";
import { printReportApiService, PrintReportPayload } from "./printreport.api";

export const usePrintReportService = () => {
  const PrintReportSelectAllMutation = useMutation({
    mutationFn: (payload: PrintReportPayload) => printReportApiService.selectAll(payload),
  });

  return {
    PrintReportSelectAllMutation,
  };
};
